import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSellerLabelProvider } from '../../../../../hooks/use-seller-label-provider';
import DataDrivenLogo from '../../../../../components/data-driven-logo';
import FormattedCurrency from '../../../../../components/formatted-currency';
import Global from '../../../../../store/global-selectors';
import { emptyObject } from 'ui-components/default-props/empty';
import { useIsFulfillmentVoided } from '../../../../../hooks/entities/selectors/fulfillments';
import { FulfillmentPropType } from '../../../../../prop-types/fulfillment';
import { FulfillmentPlanPropType } from '../../../../../prop-types/fulfillment-plan';
import { TrackingNumber } from '../../../../order-details/rate-card/read-only/label-details/tracking-number';
import { ShipmentActionsMenu } from './shipment-actions-menu';
import { ZeroCostLabel } from './zero-cost-label';
import classnames from 'classnames';
import style from './style.module.less';

export const RateCardContent = ({ fulfillmentPlan, fulfillment = emptyObject }) => {
  const { sellerLabelProviderId, serviceId: selectedServiceId, rateSummary } = fulfillmentPlan || {};
  const { code, value } = rateSummary?.rate?.shippingCost || {};
  const { fulfillmentId } = fulfillment || {};
  const { trackingNumber, url } = fulfillment?.trackingInformation || {};
  const isVoided = useIsFulfillmentVoided(fulfillmentId);
  const { labelProviderId } = useSellerLabelProvider(sellerLabelProviderId) || {};
  const services = useSelector(Global.selectSellerServices);
  const { name } = useMemo(
    () => services.find(({ serviceId }) => serviceId === selectedServiceId?.toString()) ?? emptyObject,
    [selectedServiceId, services],
  );

  return (
    <div className={style['planning-rate-card']}>
      <DataDrivenLogo className={style['provider-logo']} providerId={Number.parseInt(labelProviderId, 10)} />
      <div className={style['service-and-tracking']}>
        <div className={style['service-name']}>{name}</div>
        {trackingNumber && <TrackingNumber isVoided={isVoided} trackingNumber={trackingNumber} trackingUrl={url} />}
      </div>
      <div
        className={classnames(style['label-rate'], {
          [style['reduce-pad']]: value <= 0,
        })}
      >
        {value <= 0 ? <ZeroCostLabel className={style['zero-cost-override']} /> : <FormattedCurrency currencyCode={code} value={value} />}
      </div>
      <ShipmentActionsMenu fulfillment={fulfillment} fulfillmentPlan={fulfillmentPlan} />
    </div>
  );
};

RateCardContent.propTypes = {
  fulfillmentPlan: FulfillmentPlanPropType.isRequired,
  fulfillment: FulfillmentPropType,
};
